export const OptionsModalEnum = {
    ACCEPT: {
        icon: 'fa fa-circle-check',
        class: 'success',
        text: 'ACEPTAR'
    },
    CANCEL: {
        icon: 'fa fa-times-circle',
        class: 'info',
        text: 'CANCELAR'
    },
    DELETE: {
        icon: 'fa fa-trash',
        class: 'danger',
        text: 'ELIMINAR'
    },
    UPDATE: {
        icon: 'fa fa-pencil',
        class: 'info',
        text: 'ACTUALIZAR'
    }
};